import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 8.00024,16.0002 H 4 c -0.55228,0 -1,-0.4477 -1,-1 V 4.00024 c 0,-0.55228 0.44772,-1 1,-1 h 11 c 0.5523,0 1,0.44772 1,1 v 3.99952 h 4.0002 c 0.5523,0 1,0.44771 1,1 V 19.9998 c 0,0.5522 -0.4477,1 -1,1 H 9.00024 c -0.55228,0 -1,-0.4478 -1,-1 z m 0,-7.00044 c 0,-0.55229 0.44772,-1 1,-1 H 14 V 5.00024 H 5 V 14.0002 H 8 V 10 c 0,-0.01054 8e-5,-0.02107 2.4e-4,-0.03157 z M 10.0002,10 v 8.9998 h 9 V 9.99976 H 15.0223 C 15.0149,9.99992 15.0075,10 15,10 Z"
  }));
});
var ActionsCopy = AbstractIcon.withComponent(Icon);
ActionsCopy.displayName = 'ActionsCopy';
export default ActionsCopy;